<header class="top-bar">
  <div class="left">
    <span class="product-name">{{ productName }}</span>
    <ng-container *ngIf="isAuthenticated">
      <span class="divider"></span>
      <a routerLink="/cases" class="nav-link">Cases</a>
      <a routerLink="/create-case" class="nav-link" data-test="new-case-link">+ New test case</a>
      <a *ngIf="isAdmin()" routerLink="/admin" class="nav-link" data-test="admin-link">Admin</a>
    </ng-container>
  </div>
  <div class="right" *ngIf="isAuthenticated">
    <span class="principal">{{ principalLabel }}</span>
    <button type="button" class="logout" (click)="logout()">Sign out</button>
  </div>
</header>
